import { Checkbox } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  fileName: string;
  checked: boolean;
  onToggle: () => void;
}

/**
 * Leading multi-select checkbox of a document row — one look and aria-label across the DropZone
 * panel widgets and the asset inventory document rows.
 */
export function DocumentSelectCheckbox({ fileName, checked, onToggle }: Props) {
  const { t } = useTranslation();

  return (
    <Checkbox
      checked={checked}
      slotProps={{ input: { "aria-label": t("dropzone.fileList.selectFile", { fileName }) } }}
      onClick={(e) => e.stopPropagation()}
      onChange={onToggle}
      sx={{
        p: "9px",
        color: "action.active",
        "&.Mui-checked": { color: "action.active" },
        "& .MuiSvgIcon-root": { fontSize: 28 },
      }}
    />
  );
}
